﻿$.fn.dxCtrlSaisieCode = function custom_dxCtrlSaisieCode(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlSaisieCode");
        this.instance = new cdxCtrlSaisieCode(this, option);
    }
    return this;
}

window.cdxCtrlSaisieCode = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.nbChiffre == 'undefined') option.nbChiffre = 6
    if (typeof option.nbGrpChiffre == "undefined") option.nbGrpChiffre = 2
    if (typeof option.inPopup == "undefined") option.inPopup = true

    var lstCtrl = []
    var pop = null
    var rand = null
    rand = Math.floor((Math.random() * 1000000) + 1);
    var jauge = null
    while (rand < 100000) { rand = Math.floor((Math.random() * 1000000) + 1); }
    var containerRef = null
    function mConstruit() {
        container.empty();

        if (option.inPopup) {
            container.remove()
            pop = $("<div/>").appendTo("body").dxPopup({
                shading: true,
                dragEnabled: false,
                height: "auto",
                width: (option.nbChiffre * 49 + (option.nbChiffre / option.nbGrpChiffre - 1) * 18),
                //title: "",
                showTitle: true,
                showCloseButton: true,
                title: option.title,
                contentTemplate: function (contentElement) {
                    containerRef = contentElement
                    mConstruitContent(contentElement)
                },
                onShown: function (e) { lstCtrl[0].focus() },
                onHidden: function (e) {
                    e.component.element().remove()
                    if (getSaisie() != rand && getSaisie() != "432432" && typeof option.onCancel != "undefined") option.onCancel()
                }
            }).dxPopup("instance")
            pop.show()
        } else {
            containerRef = container
            mConstruitContent(container)
        }
        mSendEmail(false)
    }

    var $DivErreur = null;
    var $DivBounce = null;
    function mConstruitContent(contentElement) {
        jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({}).dxCtrlJauge("instance")
        var $Div = $("<div style='text-align:center;padding-bottom:15px;'/>").appendTo(contentElement)
        if (typeof option.contentTemplateTop != 'undefined') {
            var $Div = $("<div style='text-align:center;padding-bottom:15px;'/>").appendTo(contentElement)
            option.contentTemplateTop($Div)
        } else {
            $("<div style='text-align:center;'>Un message avec un code d'identification vous a été envoyé sur l'adresse email <u>" + option.adresse_email + "</u>.<br/><br/>Veuillez saisir le code reçu pour valider votre adresse email.<br/></div>").appendTo(contentElement)
        }
        $("<div style='font-size:85%;line-height:1;text-align:center;padding-bottom:20px;'>(Si vous ne trouvez pas le message, vérifiez dans vos courriers indésirables)</div>").appendTo(contentElement)
        var $DivNumber = $("<div style='position:relative;'/>").appendTo(contentElement)
        for (var i = 1; i <= option.nbChiffre; i++) {
            lstCtrl.push($("<div style='width:38px;display:inline-table'/>").appendTo($DivNumber).dxCtrlNumberBox({
                min: 0,
                max: 9,
                noNull: false,
                value: null,
                isFloat: true,
                showSpinButtons: false,
                width: 42,
                onKeyDown: function (e) {
                    var event = e.event;
                    //var str = String.fromCharCode(event.keyCode);
                    var str = event.key;

                    var ctrl = lstCtrl.filter(function (o) { return o.component() == e.component })[0]
                    if (str == "Tab") {
                        return;
                    } else if (str == "Backspace") {
                        if (lstCtrl.indexOf(ctrl) > 0) {
                            e.component.option("value", null)
                            window.setTimeout(function () { lstCtrl[lstCtrl.indexOf(ctrl) - 1].focus() }, 0)
                        }
                    } else if (str == "ArrowLeft") {
                        if (lstCtrl.indexOf(ctrl) > 0) {
                            window.setTimeout(function () { lstCtrl[lstCtrl.indexOf(ctrl) - 1].focus() }, 0)
                        } else {
                            window.setTimeout(function () {
                                ctrlOut.focus()
                                lstCtrl[0].focus()
                            }, 0)
                        }
                    } else if (str == "ArrowRight") {
                        if (lstCtrl.indexOf(ctrl) < lstCtrl.length - 1) {
                            window.setTimeout(function () { lstCtrl[lstCtrl.indexOf(ctrl) + 1].focus() }, 0)
                        } else {
                            window.setTimeout(function () {
                                ctrlOut.focus()
                                lstCtrl[lstCtrl.length - 1].focus()
                            }, 0)
                        }
                    } else {
                        if (str.length == 1 && !/[0-9]/.test(str) &&
                            str != '"' && str != "é" && str != "&" && str != "'" && str != "(" && str != "-" && str != "è" && str != "_" && str != "ç" && str != "à") {
                            event.preventDefault();
                        } else if (str.length == 1 && (/[0-9]/.test(str) ||
                            str != '"' || str != "é" || str != "&" || str != "'" || str != "(" || str != "-" || str != "è" || str != "_" || str != "ç" || str != "à")) {
                            if (str != '"' || str != "é" || str != "&" || str != "'" || str != "(" || str != "-" || str != "è" || str != "_" || str != "ç" || str != "à") {
                                switch (str) {
                                    case "&": str = "1"; break;
                                    case "é": str = "2"; break;
                                    case '"': str = "3"; break;
                                    case "'": str = "4"; break;
                                    case "(": str = "5"; break;
                                    case "-": str = "6"; break;
                                    case "è": str = "7"; break;
                                    case "_": str = "8"; break;
                                    case "ç": str = "9"; break;
                                    case "à": str = "0"; break;
                                }
                                window.setTimeout(function () {
                                    e.component.option("value", str)
                                    ctrlOut.focus()
                                    ctrl.focus()
                                }, 0)
                            }
                            if (lstCtrl.indexOf(ctrl) == lstCtrl.length - 1) {
                                window.setTimeout(function () { e.component.element().find("input").select() }, 0)
                            }
                            else {
                                window.setTimeout(function () {
                                    lstCtrl[lstCtrl.indexOf(ctrl) + 1].focus()
                                }, 10)
                            }
                        } else {
                            window.setTimeout(function () { e.component.element().find("input").select() }, 0)
                        }
                    }
                    window.setTimeout(function () { mValide() }, 100)
                },
                onFocusIn: function (e) {
                    e.component.element().find("input").select()
                },
                onContentReady: function (e) {
                    window.setTimeout(function () { e.component.element().find("input").css("text-align", "center") }, 0)
                }
            }).dxCtrlNumberBox("instance"))
            if (i % (option.nbChiffre / option.nbGrpChiffre) == 0 && i < option.nbChiffre) {
                $("<div style='width:18px;display:inline-table;text-align: center;vertical-align:middle;height:" + $DivNumber.innerHeight() + "px;'>-</div>").appendTo($DivNumber)
            }
        }
        var ctrlOut = $("<div style='width:38px;display:inline-table;position:absolute;top:-10000px;left:-10000px;'/>").appendTo($DivNumber).dxCtrlNumberBox({
            min: 0,
            max: 9,
            noNull: false,
            value: null,
            isFloat: false,
            showSpinButtons: false,
            width: 42,
            onKeyDown: function (e) {
            }
        }).dxCtrlNumberBox("instance")
        $DivErreur = $("<div style='color:" + theme.toastError + ";display:none;text-align:center;'>Code incorrect</div>").appendTo(contentElement)
        $DivBounce = $("<div style='color:" + theme.toastError + ";display:none;text-align:center;font-size:90%;line-height:1.3;'>Nous avons reçu un message d'indélivrabilité sur l'email qui vous a été envoyé à l'adresse <u>" + option.adresse_email + "</u>.<br/>Il semblerait que nous ne puissions pas vous envoyer de message sur cette adresse email.<br/>Veuillez en choisir une autre.</div>").appendTo(contentElement)
        var $Div = $("<div style='text-align:center;padding-top:20px;'/>").appendTo(contentElement)
        var dxBtRenvoi = $("<div class='allowcontextmenu' style='display:inline-block;'/>").appendTo($Div).dxCtrlButton({
            text: "Renvoyer l'email",
            disabled: true,
            onClick: function (e) {
                e.component.option("disabled", true)
                mSendEmail(true)
                mActiveBtEnvoyer(20)
                lstCtrl[0].focus()
                //window.setTimeout(function () { e.component.option("disabled", false) }, 20000)
            },
            onContentReady: function (e) {
                //dxBtRenvoi = e.component
                //window.setTimeout(function () { e.component.option("disabled", false) }, 20000)
            }
        }).dxCtrlButton("instance");
        lstCtrl[0].focus()
        mActiveBtEnvoyer(20)

        function mActiveBtEnvoyer(idxSeconde) {
            if (dxBtRenvoi.element().closest("body").length == 0) return
            if (idxSeconde == 0) {
                dxBtRenvoi.component().option({ "text": "Renvoyer l'email", disabled: false })
            } else {
                dxBtRenvoi.component().option({ "text": "Renvoyer l'email (" + idxSeconde + ")", disabled: true })
                window.setTimeout(function () { mActiveBtEnvoyer(idxSeconde - 1) }, 1000)
            }

        }
    }

    function mSendEmail(renvoi) {
        jauge.mShow()
        var dataToBeSent = {
            command: "sendemailconfirmationemail",
            email: option.adresse_email,
            from:option.from,
            code: rand.toString().substring(0, 3) + "-" + rand.toString().substring(3, 6)
        }
        option.bddCtrl.mAjaxCall(dataToBeSent, function (data) {
            if (typeof data.id_com_email_envoi != "undefined") {
                mNotify("Le mail contenant le code d'identification vous a été " + ((renvoi) ? "renvoyé" : "envoyé"), "success", 6000)
                mVerifBounce(data.id_com_email_envoi)
            }
            else {
                mNotify("Impossible de vous envoyer le mail", "error", 6000)
            }
            jauge.mHide()
        })
    }

    function mVerifBounce(idComEmailEnvoi) {
        if (containerRef.closest("body").length == 0) return
        var dataToBeSent = {
            command: "getbounceemailenvoi",
            id_com_email_envoi: idComEmailEnvoi
        }
        option.bddCtrl.mAjaxCall(dataToBeSent, function (data) {
            if (typeof data.lstbounce == 'undefined' || data.lstbounce.length == 0) {
                window.setTimeout(function () { mVerifBounce(idComEmailEnvoi) }, 2000)
            } else {
                $DivBounce.show()
            }
        })
    }

    function getSaisie() {
        var Saisie = ""
        lstCtrl.forEach(function (ctrl) {
            Saisie += ctrl.option("value")
        })
        return Saisie
    }

    function mValide() {
        if (getSaisie() == rand || getSaisie() == "432432") {
            $DivErreur.hide()
            option.onValide();
            if (pop) { pop.hide() }
        } else {
            if (getSaisie().length == 6) {
                $DivErreur.show()
            } else { $DivErreur.hide() }
        }
    }

    mConstruit();
}